import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getLookupsMachinery = async () => {
	const { data } = await axios.get(`${API}/app/maintainer/machinery/lookups`);
	return data;
};

export const getMachineries = async (filters) => {
	const { data } = await axios.get(`${API}/app/maintainer/machinery/`, { params: filters });
	return data;
};

export const getMachineryBySlug = async (filters, slug) => {
	const { data } = await axios.get(`${API}/app/maintainer/machinery/${slug}`, { params: filters });
	return data;
};

export const saveMachinery = async (params) => {
	let URL = `${API}/app/maintainer/machinery/`;

	if (params.id != null) {
		const { data } = await axios.patch(URL + params.id, params);
		return { data, params };
	}

	const { data } = await axios.post(URL, params);
	return { data, params };
};

export const deleteMachinery = async (params) => {
	const { data } = await axios.delete(`${API}/app/maintainer/machinery/${params.selected}`);
	return data;
};
